import React from "react";
import styled from "styled-components";
import Icon from "../../Components/Icons";
import { color, radius } from "../../Components/Theme";

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 16px 12px;
  @media (max-width: 599px) {
    flex-direction: row;
    overflow-x: auto;
    padding: 8px 12px;
    border-bottom: 1px solid ${color("border")};
    scrollbar-width: thin;
  }
`;

const Item = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 44px;
  padding: 8px 12px 8px 16px;
  border: 0;
  border-radius: ${radius("control")}px;
  background: ${(p) => (p.$active ? color("primary-light") : "transparent")};
  color: ${(p) => (p.$active ? color("primary") : color("text-body"))};
  font: inherit;
  font-size: 14px;
  font-weight: ${(p) => (p.$active ? 600 : 500)};
  text-align: left;
  cursor: pointer;
  transition: background-color 150ms ease-out, color 150ms ease-out;
  &:hover {
    background: ${(p) => (p.$active ? color("primary-light") : color("list"))};
  }
  &:focus-visible {
    outline: 2px solid ${color("primary")};
    outline-offset: 2px;
  }
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    bottom: 8px;
    width: 3px;
    border-radius: 3px;
    background: ${color("primary")};
    opacity: ${(p) => (p.$active ? 1 : 0)};
  }
  svg {
    flex: 0 0 auto;
  }
  span {
    min-width: 0;
  }
  @media (max-width: 599px) {
    width: auto;
    flex: 0 0 auto;
    span {
      white-space: nowrap;
    }
    &::before {
      top: auto;
      left: 12px;
      right: 12px;
      bottom: 0;
      width: auto;
      height: 3px;
    }
  }
`;

// Vertical list of settings sections: icon + label, active bar. Becomes a scrollable row below 600 px.
export default function SettingsNav({ tabs, value, onChange }) {
  return (
    <Nav aria-label="Settings">
      {tabs.map((tab, index) => (
        <Item
          key={tab.name}
          type="button"
          $active={index === value}
          aria-current={index === value ? "page" : undefined}
          onClick={() => onChange(index)}
        >
          <Icon $icon={tab.icon ?? "Settings"} $size="20px" $color="inherit" />
          <span>{tab.name}</span>
        </Item>
      ))}
    </Nav>
  );
}
